import styled from 'styled-components'
import Chart from 'devextreme-react/chart'

export const CustomChart = styled(Chart)`
  width: 90%;
  height: 90%;
`
